import { Injectable } from '@angular/core';
import { CrudService } from './crud.service';
import type {
  CreateStatementPayload,
  Statement,
  StatementMetrics,
  UpdateStatementPayload
} from '../interfaces/statement';
import type { ApiResponse } from '../interfaces/application';
import type { Observable } from 'rxjs';
import { environment } from '../../environment/environment';

@Injectable({
  providedIn: 'root'
})
export class StatementService extends CrudService<Statement, CreateStatementPayload, UpdateStatementPayload> {
  constructor() {
    super('statements');
  }

  public metrics(): Observable<ApiResponse<StatementMetrics>> {
    return this._http.get<ApiResponse<StatementMetrics>>(`${environment.api}/${this.path}/metrics`);
  }

}
